/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Custom_Property2Inputs */

const en_tables_teams_custom_property2 = /** @type {(inputs: Tables_Teams_Custom_Property2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property2`)
};

const de_tables_teams_custom_property2 = /** @type {(inputs: Tables_Teams_Custom_Property2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property2`)
};

/**
* | output |
* | --- |
* | "Property2" |
*
* @param {Tables_Teams_Custom_Property2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_custom_property2 = /** @type {((inputs?: Tables_Teams_Custom_Property2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Custom_Property2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_custom_property2(inputs)
	return de_tables_teams_custom_property2(inputs)
});